import "react-app-polyfill/ie11"; // For IE 11 support
import runtimeEnv from "@mars/heroku-js-runtime-env";
import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

//We add jss-isolate to our component so that no styles from outside can affect it <3
import { create } from "jss";
import { StylesProvider, jssPreset } from "@material-ui/styles";
import jssIsolate from "jss-isolate";
// import jssRemEmToPx from './jss-plugin-rem-em-to-px';
// import jssImportant from './jss-plugin-all-important';
// import jssIncreaseSpecificity from 'jss-increase-specificity';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import * as Sentry from "@sentry/browser";

// Set up Sentry if we have an API key avaliable for it
if (runtimeEnv().REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: runtimeEnv().REACT_APP_SENTRY_DSN,
    environment: runtimeEnv().REACT_APP_ENVIRONMENT,
  });
}

const jss = create({
  plugins: [
    jssIsolate({
      reset: "inherited", //Just reset inheritable values - makes no sense to reset anything else I think
      isolate: "widgetRoot", // Reset from the widgetRoot class - not 'root' because that's used throughout MUI - see https://github.com/cssinjs/jss/issues/326
    }),
    ...jssPreset().plugins,
    //TODO:enable these for production
    // jssRemEmToPx({baseFontSize: 16}), //NOTE: breaks icon sizes, commenting out for now
    // jssImportant(),
    // jssIncreaseSpecificity(),
  ],
});

const fonts = () => {
  let detfaultFonts = ["Roboto", "Helvetica", "Arial", "sans-serif"];

  const customFont =
    document.getElementById("evittWidgetEmbed") &&
    document.getElementById("evittWidgetEmbed").dataset["font"];

  if (customFont) {
    detfaultFonts.unshift(customFont);
  }

  return detfaultFonts;
};

// Set default theme colors
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000F9F",
    },
    secondary: {
      main: "#FF595A",
    },
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: 3,
    // Used to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: fonts().join(","),
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        background: "#FFFFFF !important",
      },
      input: {
        //for selects
        background: "#FFFFFF !important", //Important to fix selects
      },
    },
  },
});

ReactDOM.render(
  <StylesProvider jss={jss}>
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <App />
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  </StylesProvider>,
  document.getElementById("movingBuddyWidget")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
